import {
  FAIcon,
  TextLink,
  IconStyle,
  TextLinkStyle,
  Theme,
  TextLinkIconPosition,
  Drawer,
  useTranslation,
} from '@nextgen-web-framework/all';
import { CheckoutLocationHeader, ShippingTypeEnums } from '@commerce-checkout-webcomponents/ui';
import { MobileLocationProps } from '../types/propTypes';

import styles from './MobileLocation.module.scss';

const MobileLocation = ({
  shippingType,
  showLocation,
  showTopBarLocation,
  setLocation,
  onDeliveryAddressConfirm,
  disableLocationHeader,
  addressToDisplay,
  postalCodeToDisplay,
}: MobileLocationProps) => {
  const t = useTranslation();
  const leftIcon = shippingType === ShippingTypeEnums.DELIVERY ? 'truck' : 'location-dot';
  const separator = shippingType === ShippingTypeEnums.DELIVERY ? ',' : ':';

  return (
    <>
      {showTopBarLocation ? (
        shippingType === ShippingTypeEnums.DELIVERY ? (
          <FAIcon
            iconName="truck"
            iconStyle={IconStyle.REGULAR}
            className={styles['location-truck-icon']}
            onClick={() => setLocation(true)}
            data-testid="top-bar-location-test-id"
          />
        ) : (
          <FAIcon
            iconName="location-dot"
            iconStyle={IconStyle.REGULAR}
            className={styles['location-truck-icon']}
            onClick={() => setLocation(true)}
            data-testid="top-bar-location-test-id"
          />
        )
      ) : (
        <div
          data-testid="mobile-location-test-id"
          className={styles['mobile-topbar-location-header-container']}
          onClick={() => setLocation(true)}
          onKeyDown={() => setLocation(true)}
          role="presentation"
        >
          <span className={`${styles['mobile-topbar-location-header']} ${styles['visible']}`}>
            {shippingType === ShippingTypeEnums.DELIVERY ? (
              <FAIcon
                iconName="truck"
                iconStyle={IconStyle.SOLID}
                className={styles['location-truck-icon-style']}
                theme={Theme.BLACK}
                onClick={() => setLocation(true)}
                data-testid="top-bar-location-test-id"
              />
            ) : (
              <FAIcon
                iconName="location-dot"
                iconStyle={IconStyle.SOLID}
                className={styles['location-truck-icon-style']}
                theme={Theme.BLACK}
                onClick={() => setLocation(true)}
                data-testid="top-bar-location-test-id"
              />
            )}
            <span
              className={`${styles['text-container']} ${styles['text-container-left-margin']} ${styles['visible']}`}
            >
              {addressToDisplay ? (
                <>
                  <span className={styles['address-style']}>{addressToDisplay}</span>
                  {postalCodeToDisplay && (
                    <>
                      <span>{separator}</span>
                      <span className={styles['postal-code-style']}>{postalCodeToDisplay}</span>
                    </>
                  )}
                </>
              ) : (
                t('web.location.selector')
              )}
            </span>
            <TextLink
              textLinkStyle={TextLinkStyle.ICON}
              customClass="location-heading"
              text=""
              theme={Theme.BLACK}
              leftIcon={{ iconName: leftIcon, iconStyle: IconStyle.SOLID }}
              rightIcon={{ iconName: 'chevron-down', iconStyle: IconStyle.SOLID }}
              iconPosition={TextLinkIconPosition.RIGHT}
            />
          </span>
        </div>
      )}

      {showLocation && !disableLocationHeader && (
        <Drawer
          header={<div>{t('web.location.title')}</div>}
          closeIcon={true}
          closeOnBackdropClick={true}
          bottomGap={0}
          useReactPortal={true}
          portalContainerId={'react-portal-drawer'}
          onClose={() => onDeliveryAddressConfirm()}
        >
          <CheckoutLocationHeader onConfirmClick={onDeliveryAddressConfirm} />
        </Drawer>
      )}
    </>
  );
};

export default MobileLocation;
